<template>
  <div class="main_style">
    <NavBarHome v-if="navBarStyle === '1'" textColor="#000000" :iconUrl="require('@/assets/img/home/logo-2.png')"/>
    <NavBar v-else />
    <div class="header">
      <div class="header-text">
        <p class="header-title">WisChain区块链应用平台</p>
        <p class="header-desc">
          WisChain是众享科技自主研发的区块链智能部署运维平台，旨在构建高效、安全、智能、可扩展的企业级区块链架构体系。采用创新的一键部署、多框架支持及多链技术，实现不同企业区块链网络的快速搭建、可视化维护、多链连接及扩展。
        </p>
      </div>
    </div>
    <!-- 产品介绍 -->
    <div class="intro">
      <div class="commom-title">产品介绍</div>
      <div class="intro-content">
        <p>
          WisChain是众享科技自主研发的区块链智能部署运维平台，旨在构建高效、安全、智能、可扩展的企业级区块链架构体系。采用创新的一键部署、多框架支持及多链技术，实现不同企业区块链网络的快速搭建、可视化维护、多链连接及扩展。通过和企业现有CA系统平滑集成，为区块链网络提供可靠的接入安全认证。提供多业务信道和可编程链码调用资源，为企业业务运行提供定制化智能合约。
        </p>
      </div>
    </div>
    <!-- 核心功能 -->
    <div class="function">
      <div class="commom-title">核心功能</div>
      <div class="content">
        <div class="line-title">
          <div></div>
          <div>Fabric部署功能</div>
          <div></div>
        </div>
        <el-row :gutter="24" class="grid">
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-1.png"
                />
              </div>
              <div class="title">资源管理</div>
              <div class="text">
                添加部署区块链节点的资源信息，可供全局使用
              </div>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-2.png"
                />
              </div>
              <div class="title">区块链管理</div>
              <div class="text">
                创建Fabric框架的联盟发起方或联盟方网络，并对其进行管理
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-3.png"
                />
              </div>
              <div class="title">组织管理</div>
              <div class="text">
                添加组织信息
              </div>
            </div>
          </el-col>
					<el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-4.png"
                />
              </div>
              <div class="title">节点管理</div>
              <div class="text">
                添加网络节点并启动后可添加组织节点并对其进行部署
              </div>
            </div>
          </el-col>
					<el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-5.png"
                />
              </div>
              <div class="title">通道管理</div>
              <div class="text">
                可创建不同的业务通道对账本进行隔离
              </div>
            </div>
          </el-col>
					<el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-6.png"
                />
              </div>
              <div class="title">智能合约</div>
              <div class="text">
                支持添加不同业务的合约并对其进行部署
              </div>
            </div>
          </el-col>
					<el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-7.png"
                />
              </div>
              <div class="title">接入管理</div>
              <div class="text">
                给申请加入链的联盟方生成钥匙码token并进行管理
              </div>
            </div>
          </el-col>
					<el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-8.png"
                />
              </div>
              <div class="title">监控</div>
              <div class="text">
                1.可视化展示链上区块、交易、通道、合约、节点信息；2.支持查询链上所有交易和区块详情信息；3.可视化展示拓扑图信息；
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="line-title">
          <div></div>
          <div>ChainSQL部署功能</div>
          <div></div>
        </div>
        <el-row :gutter="24" class="grid">
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-9.png"
                />
              </div>
              <div class="title">资源管理</div>
              <div class="text">
                添加部署区块链节点的资源信息，可供全局使用
              </div>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-10.png"
                />
              </div>
              <div class="title">区块链管理</div>
              <div class="text">创建ChainSQL框架的联盟发起方或联盟方网络，并对其进行管理</div>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-11.png"
                />
              </div>
              <div class="title">节点管理</div>
              <div class="text">添加验证节点或非验证节点，联盟发起方必须添加3个验证且全量节点启动链，联盟方只需要启动节点加入即可共享账本</div>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-12.png"
                />
              </div>
              <div class="title">接入管理</div>
              <div class="text">
                给申请加入链的联盟方生成钥匙码token并进行管理
              </div>
            </div></el-col
          >
					<el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/function-13.png"
                />
              </div>
              <div class="title">监控</div>
              <div class="text">
                1.可视化展示链上区块、交易等信息，对资产的可视化搜索；2.支持查询链上所有交易和区块详情信息；3.可视化监控各节点运行状态；
              </div>
            </div></el-col
          >
        </el-row>
      </div>
    </div>
    <!-- 产品架构 -->
    <div class="framework">
      <div class="commom-title">产品架构</div>
      <div class="framework-content">
        <img src="https://image.peerfintech.cn/peerfintech_website_v2/product/WisChain/framework.png" />
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="advantage">
      <div class="commom-title">产品优势</div>
      <div class="advantage-content">
        <el-row :gutter="24">
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/advantage-1.png"
                />
              </div>
              <div class="title">多底层集成</div>
              <div class="text">
                支持Fabric、ChainSQL、Ethereum和Corda等区块链技术底层；支持多链集成及扩展
              </div>
            </div></el-col
          >
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/advantage-2.png"
                />
              </div>
              <div class="title">可视化运维</div>
              <div class="text">
                一键部署、企业跨域组网进行区块链网络的快速搭建、实时节点监控、区块监控、节点配置、业务数据可视化、日志分析、监控系统报警等
              </div>
            </div></el-col
          >
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/advantage-3.png"
                />
              </div>
              <div class="title">动态扩容</div>
              <div class="text">
                支持平台运行过程中动态增加成员、升级智能合约等
              </div>
            </div></el-col
          >
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/advantage-4.png"
                />
              </div>
              <div class="title">安全可控</div>
              <div class="text">
                支持CA集成、KYC认证体系，平台安全可控
              </div>
            </div></el-col
          >
        </el-row>
      </div>
    </div>
    <!-- 相关项目 -->
    <div class="project">
      <div class="commom-title">相关项目</div>
      <div class="project-content">
        <el-row :gutter="24">
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/project-1.png"
                />
              </div>
              <div class="title">江苏电力</div>
            </div></el-col
          >
					<el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/WisChain/project-2.png"
                />
              </div>
              <div class="title">用友BaaS</div>
            </div></el-col
          >
        </el-row>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar";
import NavBarHome from "@/components/NavBarHome";
import Footer from "@/components/Footer";
import {scrollMixin} from '@/mixins/scroll.js'
export default {
  mixins: [scrollMixin],
  components: {
    NavBar,
    NavBarHome,
    Footer,
  },
  mounted() {
    // 页面回退顶部
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="scss" scoped>
.main_style {
  background-color: #ffffff;
  .content-width {
    width: 1200px;
    margin: 0px auto;
  }
  .commom-title {
    padding: 70px 0px 50px;
    font-size: 32px;
    font-family: "PingFangSC-Medium";
    color: rgba(0, 0, 0, 0.85);
    line-height: 45px;
    text-align: center;
  }
  .header {
    width: 100%;
    height: 540px;
    background: url("https://image.peerfintech.cn/peerfintech_website_v2/product/WisChain/bg.png")
      center/cover no-repeat;
    .header-text {
      @extend .content-width;
      .header-title {
        font-size: 36px;
        font-family: "PingFangSC-Medium";
        color: #000000;
        line-height: 50px;
        padding-top: 160px;
      }
      .header-desc {
        width: 510px;
        color: rgba(0,0,0,0.75);
        font-size: 20px;
        line-height: 33px;
        margin-top: 36px;
      }
    }
  }
  .intro {
    padding-bottom: 70px;
    .intro-content {
      @extend .content-width;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 25px;
    }
  }
  .function {
    background: #f4f7fc;
    .content {
      @extend .content-width;
      padding-bottom: 20px;
      .line-title {
        display: flex;
        width: 100%;
        align-items: center;
        margin-bottom: 24px;
        div:nth-child(2) {
          padding: 0px 77px;
          font-size: 26px;
          color: #0075ff;
          line-height: 37px;
        }
        div:nth-child(1),
        div:nth-child(3) {
          flex: 1;
          height: 1px;
          background: #0075ff;
        }
      }
      .grid {
        padding-bottom: 26px;
        .grid-content {
          height: 352px;
          margin-bottom: 24px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 42px 24px 0px;
          .img {
            width: 124px;
            height: 124px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .title {
            padding: 24px 0px;
            font-size: 22px;
            font-family: "PingFangSC-Medium";
            color: rgba(0, 0, 0, 0.85);
            line-height: 30px;
          }
          .text {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 22px;
            text-align: center;
          }
        }
      }
    }
  }
  .framework {
    padding-bottom: 70px;
    .framework-content {
      @extend .content-width;
      img {
        width: 100%;
      }
    }
  }
  .advantage {
    background: #f4f7fc;
    .advantage-content {
      @extend .content-width;
      padding-bottom: 70px;
      .el-row {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .grid-content {
        height: 370px;
        background: #ffffff;
        box-shadow: 3px 3px 15px 0px rgba(0, 0, 0, 0.1);
        padding: 40px 48px 0px 40px;
        .img {
          width: 124px;
          height: 124px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          padding: 24px 0px;
          font-size: 22px;
          font-family: "PingFangSC-Medium";
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
        }
        .text {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
        }
      }
    }
  }
  .project {
    .project-content {
      @extend .content-width;
      padding-bottom: 70px;
      .grid-content {
        height: 194px;
        background: #f4f7fc;
        display: flex;
        flex-direction: column;
        align-items: center;
				padding:24px 48px 0px;
        .img {
          width: 66px;
          height: 66px;
          margin-bottom: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          font-size: 22px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
					text-align: center;
        }
      }
      .el-row {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    
  }
}
</style>
